export const ListQueryKey = 'activityRoomConfigs';
export const DetailQueryKey = 'activityRoomConfig';
export const Urls = {
  selectUrl: '/RoomConfig/list',
  updateUrl: '/RoomConfig/update',
  deleteUrl: '/RoomConfig/delete',
  createUrl: '/RoomConfig/create',
  detailUrl: '/RoomConfig/detail'
}; // /api/ZlQyConfig/list